import { GlobalOutlined, InfoCircleOutlined } from "@ant-design/icons";
import { Button, Space, Divider, Typography } from "antd";
import { useTranslation } from "react-i18next";
import VersionControl from "@components/VersionControl";

const { Text } = Typography;

function Settings() {
  const { i18n } = useTranslation();

  const currentLanguage = i18n.language;

  const handleLanguageChange = (language: string) => {
    i18n.changeLanguage(language);
    localStorage.setItem("i18nextLng", language);
  };

  const languages = [
    { code: "en", flag: "🇺🇸", label: "English" },
    { code: "zh", flag: "🇨🇳", label: "中文" },
    { code: "vi", flag: "🇻🇳", label: "Tiếng Việt" },
    { code: "th", flag: "🇹🇭", label: "ภาษาไทย" },
    { code: "es", flag: "🇪🇸", label: "Español" },
  ];

  return (
    <div style={{ padding: "8px 0", minWidth: "250px" }}>
      {/* Language Settings */}
      <div style={{ padding: "8px 16px" }}>
        <Text strong style={{ display: "flex", alignItems: "center", marginBottom: "8px" }}>
          <GlobalOutlined style={{ marginRight: "8px" }} />
          Language / 语言
        </Text>
        <Space direction="vertical" size={4} style={{ width: "100%" }}>
          {languages.map(({ code, flag, label }) => (
            <Button
              key={code}
              type={currentLanguage === code ? "primary" : "text"}
              size="small"
              block
              onClick={() => handleLanguageChange(code)}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-start",
                textAlign: "left",
              }}
            >
              <Space size={4}>
                <span>{flag}</span>
                <span>{label}</span>
              </Space>
            </Button>
          ))}
        </Space>
      </div>

      <Divider style={{ margin: "8px 0" }} />

      {/* Version Control */}
      <div style={{ padding: "8px 16px" }}>
        <Text strong style={{ display: "flex", alignItems: "center", marginBottom: "8px" }}>
          <InfoCircleOutlined style={{ marginRight: "8px" }} />
          Version Control
        </Text>
        <Space direction="vertical" size={4} style={{ width: "100%" }}>
          <VersionControl />
          {/* <Text type="secondary" style={{ fontSize: "12px" }}>
            Version: {process.env.REACT_APP_VERSION ?? "1.0.0"}
          </Text> */}
        </Space>
      </div>
    </div>
  );
}

export default Settings;
